import { BodySecondary, H5 } from '@liveauctioneers/hammer-ui-core/text';
import * as React from 'react';
import styled from 'styled-components';

type Props = {
    expertise: string;
    id: number;
    imgSrc: string;
    name: string;
};

const Curator = ({ expertise, id, imgSrc, name }: Props) => (
    <StyledCurator key={id}>
        <StyledImageContainer>
            <StyledImage
                alt={name}
                height={140}
                src={imgSrc}
                width={140}
            />
        </StyledImageContainer>
        <StyledDetails>
            <H5>{name}</H5>
            <BodySecondary color="secondary">{expertise}</BodySecondary>
        </StyledDetails>
    </StyledCurator>
);

export default Curator;

const StyledCurator = styled.div`
    align-items: center;
    color: ${({ theme }) => theme.colors.black};
    display: flex;
    flex-direction: column;
`;

const StyledImageContainer = styled.div`
    align-items: center;
    border-radius: 50%;
    display: flex;
    height: 140px;
    justify-content: center;
    margin-bottom: 10px;
    overflow: hidden;
    position: relative;
    width: 140px;
`;

const StyledImage = styled.img`
    max-height: 100%;
    max-width: 100%;
    content-fit: contain;
`;

const StyledDetails = styled.div`
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    text-align: center;

    h5 {
        margin-bottom: 4px;
    }
`;
